// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';

const ClaimViews = props =>
    <section>
        {props.children}
    </section>;

ClaimViews.displayName = 'ClaimViews';
ClaimViews.propTypes = {
    children: PropTypes.node
};

export default ClaimViews;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-views.js